import { useState } from "react";
import { BsEyeFill, BsLockFill } from "react-icons/bs";

import type { UserTestDto } from "~/data/user-test/user-test.dto";

import { Dialog } from "~/ui/shared/dialog";
import logo from "~/ui/shared/assets/logo-extended.png";

import { HtmlContent } from "../shared/html-content";

interface Props {
  data: UserTestDto["test"]["test_exams"];
  onUnlock?: (examId: string) => void;
}

export function Exams({ data: exams, onUnlock }: Props) {
  return (
    <ul className="grid gap-4">
      {exams.map((it, i) => (
        <li
          className="flex rounded-[10px] items-center justify-between shadow-card p-4"
          key={`exam:${i}`}
        >
          <p className="text-[15px] font-semibold">{it.title}</p>
          <div className="flex items-center gap-2">
            <Dialog>
              <Dialog.Trigger asChild>
                <button
                  type="button"
                  aria-label="Visualizar"
                  className="p-1 rounded-md bg-gray-50 text-primary-1"
                >
                  <BsEyeFill size={20} />
                </button>
              </Dialog.Trigger>
              <Dialog.Content className="max-w-xl">
                <h3 className="text-sm leading-4 uppercase font-semibold font-alternative">
                  {it.title}
                </h3>
                <div>
                  <header className=" border-b-[5px] border-b-secondary-1 pb-5 mb-6">
                    <img
                      className="block mx-auto h-[95px]"
                      height={95}
                      src={logo}
                    />
                  </header>
                  <div
                    className="overflow-y-auto"
                    style={{ maxHeight: "calc(100svh - 254px)" }}
                  >
                    {it.content && <HtmlContent content={it.content} />}
                    {it.file_url && (
                      <img
                        className="block mx-auto"
                        src={import.meta.env.VITE_API_URL + it.file_url}
                      />
                    )}
                  </div>
                </div>
              </Dialog.Content>
            </Dialog>

            {onUnlock && <UnlockButton onClick={() => onUnlock(it.id)} />}
          </div>
        </li>
      ))}
    </ul>
  );
}

function UnlockButton(props: React.ComponentProps<"button">) {
  const [unlocked, setUnlocked] = useState(false);
  if (unlocked) return null;
  return (
    <button
      {...props}
      type="button"
      onClick={(e) => {
        props.onClick?.(e);
        setUnlocked(true);
      }}
      aria-label="Liberar"
      className="p-1 rounded-md bg-gray-50 text-primary-1"
    >
      <BsLockFill size={20} />
    </button>
  );
}
